/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host > div {
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 15px;
}
:host > div .chart-wrapper {
  height: 100%;
  position: absolute;
  width: calc(100% - 20px);
}
:host > div > div {
  width: 100%;
  height: 100%;
}
:host .wv-tooltip {
  max-width: 300px;
}
:host .wv-tooltip div {
  word-wrap: anywhere;
}